const DashbordIcon = ({ size = 20, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M4.3335 3.33325H15.6668C16.2191 3.33325 16.6668 3.78097 16.6668 4.33325V5.66659C16.6668 6.21887 16.2191 6.66659 15.6668 6.66659H4.3335C3.78121 6.66659 3.3335 6.21887 3.3335 5.66659V4.33325C3.3335 3.78097 3.78121 3.33325 4.3335 3.33325Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.3335 9.16675H7.3335C7.88578 9.16675 8.3335 9.61446 8.3335 10.1667V15.6667C8.3335 16.219 7.88578 16.6667 7.3335 16.6667H4.3335C3.78121 16.6667 3.3335 16.219 3.3335 15.6667V10.1667C3.3335 9.61446 3.78121 9.16675 4.3335 9.16675Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8335 9.16675H15.6668C16.2191 9.16675 16.6668 9.61446 16.6668 10.1667V10.6667C16.6668 11.219 16.2191 11.6667 15.6668 11.6667H11.8335C11.2812 11.6667 10.8335 11.219 10.8335 10.6667V10.1667C10.8335 9.61446 11.2812 9.16675 11.8335 9.16675Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8335 14.1667H15.6668C16.2191 14.1667 16.6668 14.6145 16.6668 15.1667V15.6667C16.6668 16.219 16.2191 16.6667 15.6668 16.6667H11.8335C11.2812 16.6667 10.8335 16.219 10.8335 15.6667V15.1667C10.8335 14.6145 11.2812 14.1667 11.8335 14.1667Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default DashbordIcon
